import { render, staticRenderFns } from "./purchasing-statistics.vue?vue&type=template&id=462e3f8c&"
import script from "./purchasing-statistics.vue?vue&type=script&lang=ts&"
export * from "./purchasing-statistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports